import { useContext } from 'react';
import { LayoutContext } from '../constants';

export const useLayout = () => {
    const { headerRef, sideRef, bodyRef, contentRef, wrapRef } = useContext(LayoutContext);
    return { headerRef, sideRef, bodyRef, contentRef, wrapRef };
};
